import Http from '@/apis/http';

export const fetchCommonData = () => {
  return Http.get('/common');
};
